var withVoid = function withVoid(editor) {
  var isVoid = editor.isVoid;
  var VOID_ELEMENTS = ['image', 'formula', 'column'];
  editor.isVoid = function (element) {
    return VOID_ELEMENTS.includes(element.type) ? true : isVoid(element);
  };
  return editor;
};
export default withVoid;